import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top whenever the pathname changes.
 * React Router does NOT restore scroll on client-side navigation by default —
 * clicking a demo card was landing the user mid-page. This component fixes it.
 * Uses "instant" behaviour to avoid a visible scroll animation on route change.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // Use instant scroll — smooth would look janky when the previous page was
    // already scrolled far down.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

export default ScrollToTop;
